
















































































































































































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import Header from "@/components/header/OLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import AdminsApi from "@/services/AdminsApi";
import OrganizationsApi from "@/services/Organizations";
import { Admin, NewOrganization, Organization, OrganizationAdmin, UpdateOrganization } from "@/api/lab-base-api-client";
import CheckAdminLogin from "@/utils/CheckAdminLogin";
import CTooltip from "@/components/CTooltip.vue";
import AuthModule from "@/store/auth";
import TooltipModule from "@/store/tooltip";
import { sortCreatedAt } from "@/utils/Util";
import { ValidationObserver } from "vee-validate";
import dayjs from "dayjs";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    Footer,
    CTooltip,
  },
})
export default class MUserList extends CheckAdminLogin {
  // tableのheader設定配列
  private headers = [
    {
      text: "organization name",
      align: "start",
      sortable: false,
      value: "name",
    },
    {
      text: "account Num",
      align: "start",
      value: "accountNumber",
    },
    { text: "", value: "actions", sortable: false },
  ];

  // tableのデータ配列
  private listItems: Organization[] = [];

  private admins: Admin[] = [];

  private organizationAdmins: OrganizationAdmin[] = [];

  // 削除済みユーザー表示スイッチ初期値
  private includeDelete = false;

  private today = dayjs(new Date()).format("YYYYMMDD");

  // 入力、表示の日付
  private inputDate = "";

  // v-date-picker
  private activePicker: string | null = null;

  // createのv-menu
  private createMenu = false;

  // editのv-menu
  private editMenu = false;

  // tableの検索初期値
  private search = "";

  private isCreateDialog = false;

  private form: NewOrganization = {
    name: "",
    phoneNumber: "",
    contractPeriod: "",
    accountNumber: 0,
    itnavRepresentative: "",
  };

  private defaultOrganizationForm: NewOrganization = {
    name: "",
    phoneNumber: "",
    contractPeriod: "",
    accountNumber: 0,
    itnavRepresentative: "",
  };

  // 編集の対象userのuuid
  private uuid = "";

  private isEditDialog = false;

  private editForm: UpdateOrganization = {
    name: "",
    phoneNumber: "",
    contractPeriod: "",
    accountNumber: 0,
    itnavRepresentative: "",
  };

  private defaultEditForm: UpdateOrganization = {
    name: "",
    phoneNumber: "",
    contractPeriod: "",
    accountNumber: 0,
    itnavRepresentative: "",
  };

  private dialogDelete = false;

  // 削除ダイアログの確認checkboxの初期値
  private checkbox = false;

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // ページ読み込み時に実行
  private async mounted() {
    this.fetchList();
    this.listItems.sort(sortCreatedAt);
  }

  // 団体一覧の取得
  private async fetchList() {
    const organizationRes = await OrganizationsApi.instance.getOrganizations();
    this.listItems = organizationRes.data.data.items;
  }

  // 管理者取得
  private async getAdmins() {
    const adminsRes = await AdminsApi.instance.getAdmins();
    this.admins = adminsRes.data.data.items;
  }

  // 団体管理者取得
  private async getOrganizationAdmins(organizationUuid: string) {
    const getOrganizationsByUuidRes = await OrganizationsApi.instance.getOrganizationsByUuid(organizationUuid);
    if (getOrganizationsByUuidRes.data.data.organization.organizationAdmins) {
      this.organizationAdmins = getOrganizationsByUuidRes.data.data.organization.organizationAdmins;
    }
  }

  // 「団体登録」クリックで実行
  private onNewItem() {
    this.isCreateDialog = true;
    this.getAdmins();
  }

  // date-pickerをchangeしたときに実行
  private changeDatePicker(date: Date) {
    this.inputDate = dayjs(date).format("YYYYMMDD");
    this.createMenu = false;
    this.editMenu = false;
  }

  @Watch("menu")
  private async clickCalender() {
    setTimeout(() => {
      this.activePicker = "YEAR";
    });
  }

  // 登録ダイアログ「save」で実行、団体登録
  private async createSubmit() {
    // 日付変換
    this.form.contractPeriod = dayjs(this.inputDate).format("YYYY-MM-DD");

    try {
      const organizationRes = await OrganizationsApi.instance.createOrganization(this.form);
      if (!organizationRes?.data?.data?.organization) {
        return;
      }
      this.closeCreate();
      this.includeDelete = false;
      this.fetchList();
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // 登録ダイアログを閉じる
  private closeCreate() {
    this.isCreateDialog = false;
    this.form = { ...this.defaultOrganizationForm };
    TooltipModule.commitIsShow(false);
    this.resetValidation();
  }

  // 編集アイコンclickで実行
  private async onEditItem(item: Organization) {
    this.uuid = item.uuid;
    this.getOrganizationAdmins(this.uuid);
    this.getAdmins();
    this.isEditDialog = true;
    this.editForm.name = item.name;
    this.editForm.phoneNumber = item.phoneNumber;
    this.inputDate = dayjs(item.contractPeriod).format("YYYYMMDD");
    this.editForm.accountNumber = item.accountNumber;
    this.editForm.itnavRepresentative = item.itnavRepresentative;
    this.editForm.organizationRepresentative = item.organizationRepresentative;
  }

  // 編集ダイアログの「save」クリックで実行
  private async saveEdit() {
    // 日付変換
    this.editForm.contractPeriod = dayjs(this.inputDate).format("YYYY-MM-DD");
    try {
      await OrganizationsApi.instance.updateOrganizationByUuid(this.uuid, this.editForm);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
    this.closeEdit();
    this.fetchList();
  }

  // 編集ダイアログを閉じる
  private closeEdit() {
    this.isEditDialog = false;
    this.editForm = { ...this.defaultEditForm };
    this.uuid = "";
  }

  // 削除アイコンclickで実行
  private async onDeleteItem(uuid: string) {
    this.dialogDelete = true;
    this.uuid = uuid;
  }

  // 削除ダイアログの「ok」クリックで実行
  private async deleteItem() {
    try {
      await OrganizationsApi.instance.deleteOrganizationByUuid(this.uuid);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
    this.closeDelete();
    await this.fetchList();
  }

  // 削除ダイアログを閉じる
  private closeDelete() {
    this.dialogDelete = false;
    this.uuid = "";
    this.checkbox = false;
  }

  // 削除済み表示スイッチ切り替え時に実行
  private async onIncludeDelete() {
    if (this.includeDelete === true) {
      const organizationRes = await OrganizationsApi.instance.getOrganizations(
        undefined,
        undefined,
        undefined,
        undefined,
        this.includeDelete
      );
      this.listItems = organizationRes.data.data.items;
      this.listItems.sort(sortCreatedAt);
    } else {
      this.fetchList();
    }
  }

  // 行のクリックで実行
  private clickRow(item: { uuid: string }) {
    if (this.includeDelete) {
      return;
    }
    this.$router.push({ name: "MOrganizationDetail", params: { uuid: item.uuid } });
  }

  // バリデーションリセット
  private resetValidation() {
    if (!this.$refs.observer) {
      return;
    }
    (this.$refs.observer as InstanceType<typeof ValidationObserver>).reset();
  }
}
